import { Alert, Button, Grid } from "@mui/material";
import { FormEvent, useState } from "react";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { redirect } from "react-router";
import { PaperHeader } from "../../_components/paper/header.paperComponent";
import { toastr } from "../../_components/toastr/toastr";
import { accountService } from "../../_services/accounts.service";
import { theme } from "../../_styles/theme.styles";
import { Link } from "react-router-dom";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { PrimaryButton } from "../../_components/button/primary.button";

const useStyles = {
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    header: {
        marginLeft: theme.spacing(-8),
    },
    mainBackground: {
    },

    logo: {
        width: "100%",
        height: "100px",
    },
    backToLogin: {
        paddingTop: "20px",
        cursor: "pointer"
    }
};

export function LoginForgotPassword() {
    const [email, setEmail] = useState("");
    const [isEmailReset, resetEmail] = useState(false);
    const [isLoading, setLoading] = useState(false);

    if (accountService.currentUserValue) {
        redirect('/');
    }

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.forgotPassword(email)
            .then(
                (item => { resetEmail(true); }),
                ((err) => {
                    toastr.error("Something went wrong. Please try again later");
                }))
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div style={useStyles.paper as React.CSSProperties}>
            <div style={useStyles.header}>
                <PaperHeader title='Forgot Password' icon='lock'></PaperHeader>
            </div>

            {isEmailReset === true &&
                <>
                    <Alert severity="success">Please check your email and click on the provided link to reset your password.</Alert>

                </>
            }

            {isEmailReset === false &&
                <>
                    <Alert severity="warning">Please enter your email address to request a password reset.</Alert>
                    <ValidatorForm sx={useStyles.form} onSubmit={submit} noValidate>

                        <Grid container>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    value={email}
                                    disabled={isLoading}
                                    onChange={(e: any) => setEmail(e.target.value.toString())}
                                    validators={['required', 'isEmail']}
                                    errorMessages={['This field is required', 'Email is not valid']}
                                    autoFocus
                                />
                            </Grid>

                            <Grid item xs={12}>

                                <PrimaryButton
                                    type="submit"
                                    variant="primary"
                                    disabled={isLoading}
                                >
                                    Request Password Reset
                                </PrimaryButton>
                            </Grid>

                        </Grid>
                    </ValidatorForm>

                </>
            }

            <Link to={"/login"} style={useStyles.backToLogin}>
                Back to Log In screen
            </Link>

        </div>
    );
}